// @flow
import { useSelector } from "react-redux";
import { ADDRESS_NOT_FOUND_ID } from "@nested/brand";
import { MultiStageForm, Question } from "../components/MultiStageForm";
import {
  AddressAllowNotFound,
  CustomerIntent,
  Email,
  ManualAddress,
  Name,
  PhoneNumber,
  PersonalInformationAlreadySaved,
  Urgency,
} from "../questions";
import { usePersonalInformationOnSubmit } from "./usePersonalInformationOnSubmit";

export const PersonalInformationForm = () => {
  const { onSubmit, errorMessage, setErrorMessage } =
    usePersonalInformationOnSubmit();

  const previouslyCreatedDealId = useSelector(
    (state) => state.onboardingForm.dealId,
  );

  if (previouslyCreatedDealId) {
    return <PersonalInformationAlreadySaved />;
  }

  return (
    <>
      <MultiStageForm
        onSubmit={onSubmit}
        submitError={errorMessage}
        setSubmitError={setErrorMessage}
        formType="personal-information"
        lastButtonLabel="Save and continue"
      >
        <Question
          route="/get-started"
          component={AddressAllowNotFound}
          name="address"
        />
        <Question
          route="/get-started/manual-address"
          component={ManualAddress}
          name="manualAddress"
          skip={({ address }) => address?.id !== ADDRESS_NOT_FOUND_ID}
        />
        <Question
          route="/get-started/where-in-your-home-move"
          component={CustomerIntent}
          name="customerIntent"
        />
        <Question
          route="/get-started/when-will-you-list"
          component={Urgency}
          name="urgency"
          skip={({ customerIntent }) => customerIntent !== "THINKING_ABOUT_IT"}
        />
        <Question route="/get-started/email" component={Email} name="email" />
        <Question route="/get-started/name" component={Name} name="name" />
        <Question
          route="/get-started/phone-number"
          component={PhoneNumber}
          name="phone"
        />
      </MultiStageForm>
    </>
  );
};
